export default __webpack_public_path__ + "static/media/q15.719d0199.png";